import { render, staticRenderFns } from "./linkDigiProductModel_single.vue?vue&type=template&id=aaec67ae"
import script from "./linkDigiProductModel_single.vue?vue&type=script&lang=js"
export * from "./linkDigiProductModel_single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports